import React from 'react';
import { Button, Box } from '@honda-canada/design-system-react';
import { isEmpty } from 'lodash';

import { useTranslation } from 'react-i18next';
import themeStyles from './styles/PricingDetails.styles';
import FinanceAndDownPayment from './FinanceAndDownpayment';
import FinancePaymentDetails from '../FinancePaymentDetails/FinancePaymentDetails';
import PricingDetails from './PricingDetails';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Error from './Error';
import { usePriceAndFinanceDetails } from '../PriceAndFinanceContext';

const FindDealerCTAContainer = themeStyles.apply(Box, 'FindDealerCTAContainer');
const FindDealerCTAButton = themeStyles.apply(Button, 'FindDealerCTAButton');

const PriceAndFinanceDetails = () => {
  const { t } = useTranslation();
  const { isLoading, hasError, pricing, finance, isSellingProvince, frieghtPDIFeesCost } = usePriceAndFinanceDetails();

  const dealerLocatorLink = t('Shared.Common.dealersPageUrl');

  const hasPrice = !isEmpty(pricing);
  if (isLoading)
    return (
      <>
        <LoadingSpinner />
        <FindDealerCTAContainer>
          <FindDealerCTAButton styling="primary" as="a" href={dealerLocatorLink}>
            {t('Sub-apps.PriceAndFinance.findLocalDealerButton')}
          </FindDealerCTAButton>
        </FindDealerCTAContainer>
      </>
    );
  if (hasError)
    return (
      <>
        <Error message={t('Sub-apps.PriceAndFinance.unableToLoadError')} />
        <FindDealerCTAContainer>
          <FindDealerCTAButton styling="primary" as="a" href={dealerLocatorLink}>
            {t('Sub-apps.PriceAndFinance.findLocalDealerButton')}
          </FindDealerCTAButton>
        </FindDealerCTAContainer>
      </>
    );
  return (
    <>
      <PricingDetails pricing={pricing} isSellingProvince={isSellingProvince} frieghtPDIFeesCost={frieghtPDIFeesCost} />
      <FinanceAndDownPayment finance={finance} hasPrice={hasPrice} isLoading={isLoading} />
      <FinancePaymentDetails
        pricing={pricing}
        finance={finance}
        isLoading={isLoading}
        showSellingPrice={isSellingProvince}
      />
    </>
  );
};

export default PriceAndFinanceDetails;
